module.exports = __webpack_public_path__ + "media/mlc.53f30e34.mp4";